import { Circle, View, XStack } from 'tamagui'
import { FormHelpText } from './form-help-text'

export function FormHelpBullet({ children }: { children: React.ReactNode }) {
  return (
    <XStack mx="$2" gap="$2" items="flex-start">
      <View pt="$2.5">
        <Circle size="$0.75" bg="$black11" />
      </View>
      <FormHelpText>{children}</FormHelpText>
    </XStack>
  )
}
